'use strict';

angular.module('studies')
    .controller('StudyController', ['AccountManager', function(AccountManager) {
        var vm = this;

        vm.permissions = {
            edit: false,
            subscription: false,
        };

        vm.$onInit = function() {
            AccountManager.init()
                .then(function() {
                    vm.permissions.edit = AccountManager.hasStudyPermission(vm.study.subdomain, 'edit study info');
                    vm.permissions.subscription = AccountManager.hasStudyPermission(vm.study.subdomain, 'read subscription');
                })
        };

        vm.get = function(property) {
            return property ? vm.study[property] : vm.study;
        };
    }]);
